import React, { useCallback } from "react";
import { Route, Switch } from "react-router-dom";
import client from "@culturehq/client";
import { Loader } from "@culturehq/components";

import { useProfile } from "app/context";
import { useFetch } from "app/hooks";
import { getProfilePath } from "app/links";

import NotFound from "components/NotFound";

import ActivityOptions from "components/person/ActivityOptions";
import Recognitions from "components/person/Recognitions";
import UserRsvpdEvents from "components/person/UserRsvpdEvents";
import UserFeed from "components/person/UserFeed";

const UserActivityRoutes = ({ baseUrl, fetching = false, isProfile, profile, user }) => (
  <div className="User-Activity">
    <Loader loading={fetching}>
      <div className="clearfix box-shadow">
        <ActivityOptions user={user} isProfile={isProfile} />
        <div className="row">
          <Switch>
            <Route
              exact
              path={`${baseUrl}/posts`}
              render={() => <UserFeed user={user} isProfile={isProfile} />}
            />
            <Route
              exact
              path={`${baseUrl}/events/:page?`}
              render={() => <UserRsvpdEvents user={user} />}
            />
            {profile.organization.recognitionsEnabled && (
              <Route
                exact
                path={`${baseUrl}/recognitions/:page?`}
                render={() => <Recognitions user={user} />}
              />
            )}
          </Switch>
        </div>
      </div>
    </Loader>
  </div>
);

const PersonUser = ({ profile, userId }) => {
  const { error, fetching, json: { user = {} }, onUpdate } = useFetch(
    () => client.getUser({ userId }),
    [userId]
  );

  const onChange = useCallback(
    update => onUpdate(() => ({ user: update })),
    [onUpdate]
  );

  if (error && error.status === 404) {
    return <NotFound />;
  }

  if (error) {
    throw error;
  }

  return (
    <UserActivityRoutes
      baseUrl={`${getProfilePath(user)}/activity`}
      fetching={fetching}
      isProfile={false}
      onChange={onChange}
      profile={profile}
      user={user}
    />
  );
};

const UserActivity = ({ match }) => {
  const { profile } = useProfile();

  if (match.params.user) {
    return <PersonUser profile={profile} userId={match.params.user} />;
  }

  return <UserActivityRoutes baseUrl="/profile/activity" isProfile profile={profile} user={profile} />;
};

export default UserActivity;
